import { defaultVariantMapping } from "./utils/defaultVariantMapping/defaultVariantMapping.js";
import { typographyVariants } from "./utils/typographyVariants/typographyVariants.js";
const typography = {
  ...typographyVariants
};
const MuiTypography = {
  defaultProps: {
    variant: "Lato Body 1",
    variantMapping: defaultVariantMapping
  }
};
export {
  MuiTypography,
  typography
};
